import * as React from 'react';
import type { SVGProps } from 'react';
const SvgAdjust = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      fill="#787887"
      d="M8 1.25C4.281 1.25 1.25 4.281 1.25 8s3 6.75 6.75 6.75c3.688 0 6.75-3 6.75-6.75 0-3.687-3.031-6.75-6.75-6.75m0-1c4.25 0 7.75 3.5 7.75 7.75 0 4.281-3.5 7.75-7.75 7.75A7.75 7.75 0 0 1 .25 8C.25 3.75 3.719.25 8 .25M7 4.156C5.313 4.563 4 6.125 4 8c0 1.906 1.313 3.469 3 3.875zM8 3v10c-2.781 0-5-2.219-5-5 0-2.75 2.219-5 5-5"
    />
  </svg>
);
export default SvgAdjust;
